import { tv } from "../../variants/tv.js";
const loadingSpinnerVariants = tv({
    base: 'bg-neutral-1 left-0 top-0 flex flex-grow justify-center border-0 transition-opacity duration-500 ease-in-out',
    slots: {
        wrapper: "bg-neutral-1 flex flex-grow flex-col items-center justify-center border-0 delay-100"
    },
    variants: {
        loading: {
            true: {
                base: 'opacity-80'
            },
            false: {
                base: 'opacity-0'
            }
        },
        scrollable: {
            true: {
                base: 'absolute',
                wrapper: 'absolute flex'
            },
            false: {
                base: 'absolute',
                wrapper: 'absolute flex'
            }
        },
        show: {
            false: {
                base: 'hidden'
            }
        }
    },
    defaultVariants: {
        loading: false,
        scrollable: false,
        show: false
    }
});
export { loadingSpinnerVariants };
